import { FaRegSquare as BoxIcon } from 'react-icons/fa';

export default BoxIcon;
